import { Injectable } from '@angular/core';

import { EnvironmentActions, AccountActions } from '@app/core/actions';
import { CookiesService } from '@app/core/services/cookies.service';
import * as fromRoot from '@app/reducers';
import { Store } from '@ngrx/store';
import { Observable, ReplaySubject } from 'rxjs';
import { map, take, withLatestFrom } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class DomainRedirectionGuard  {

  constructor(
    private store$: Store<fromRoot.State>,
    private cookiesService: CookiesService,
  ) { }

  canActivate(): Observable<boolean> {
    return this.checkDomainRedirection().pipe(map((domainChecked: boolean) => {
      return domainChecked;
    }));
  }

  checkDomainRedirection(): Observable<boolean> {
    const domainChecked$ = new ReplaySubject<boolean>();
    this.store$.pipe(
      withLatestFrom(
        this.store$.select(fromRoot.getCurrentDomain),
        this.store$.select(fromRoot.getUserTeams),
      ),
      take(1),
    ).subscribe(([state, currentDomain, teams]: any[]) => {
      if (currentDomain?.redirect) {
        this.store$.dispatch(EnvironmentActions.FollowDomainRedirect({ redirect: currentDomain.redirect }));
      } else if (teams?.length > 0) {
        // Checking if current subdomain in one user's teams
        const lastActiveTeam = this.cookiesService.getCookie('lastActiveTeam');
        // need to check if lastActiveTeam is part of current user team (maybe user hase several accounts)
        const hasAccess = teams.find(team => lastActiveTeam?.domain === team?.domain);
        const resolvedTeam = hasAccess ? hasAccess : teams[0];
        this.store$.dispatch(AccountActions.updateActiveTeam({ team: resolvedTeam }));
        if (teams.find(team => currentDomain?.team === team?.id)) {
          const domainInUserTeams = teams.find(team => currentDomain?.team === team?.id);
          this.store$.dispatch(AccountActions.updateActiveTeam({ team: domainInUserTeams }));
          domainChecked$.next(true);
        } else if (currentDomain?.region) { // other premium domain
          domainChecked$.next(true);
        } else {
          this.store$.dispatch(EnvironmentActions.redirectToSelectedDomain());
        }
      } else {
        domainChecked$.next(true);
      }
    });
    return domainChecked$.asObservable();
  }
}
